import * as z from "zod";

export enum errorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
}

export const requestErrorSchema = z.object({
  code: z.nativeEnum(errorCode),
  message: z.string().optional(),
  payload: z.unknown().optional(),
});

export type RequestError = z.infer<typeof requestErrorSchema>;
